import { Button, Dialog, DialogContent, DialogTitle, Grid, makeStyles } from '@material-ui/core';
import { defer } from '@thalesrc/js-utils';
import React, { useCallback, useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import {
  saveAdminTypeDefinition,
  TypeDefinitionResult,
  updateAdminTypeDefinition,
} from 'api/hs/definitions/ppe-definitions/type-definitions';
import TextField from 'Common/Form/TextField';
import { AlertContext } from 'context/alert.context';
import { useAsyncEffect } from 'utils';

import Checkbox from '../../../../../Common/Form/Checkbox';
import { ResourceContext } from '../../../../../context/resource.context';

const useStyles = makeStyles(theme => ({
  dialog: {
    width: '100%',
  },
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

interface Props {
  open: boolean;

  onClose(success: boolean): void;

  data: TypeDefinitionResult;
}

export default function TypeDefinitionsForm({ open, onClose, data }: Props) {
  const classes = useStyles();
  const { reset, setValue, trigger, ...formMethods } = useForm();
  const { showMessage } = useContext(AlertContext);
  const { reload } = useContext(ResourceContext);
  const handleSubmit = useCallback(
    async values => {
      try {
        if (!data?.id) {
          await saveAdminTypeDefinition({
            ...values,
            isSerialNumberMandatory: values?.isSerialNumberMandatory === null ? false : values?.isSerialNumberMandatory,
          });
          showMessage('Ekleme işlemi başarılı.', 'success', 'info');
        } else {
          await updateAdminTypeDefinition({
            id: data.id,
            ...values,
            isSerialNumberMandatory: values?.isSerialNumberMandatory === null ? false : values?.isSerialNumberMandatory,
          });
          showMessage('Güncelleme işlemi başarılı.', 'success', 'info');
        }
        onClose(true);
        await reload('ppeTypeDefinitions');
      } catch (err) {
        showMessage('İşlem sırasında sorun oluştu.', 'error', 'info');
        onClose(false);
      }
    },
    [data, onClose, showMessage, reload]
  );

  useAsyncEffect(async () => {
    if (!open) {
      return;
    }
    if (data) {
      await defer();
      for (const [key, value] of Object.entries(data)) {
        setValue(key, value === null ? '' : value);
      }

      trigger();
    } else {
      reset({
        label: '' as any,
        isSerialNumberMandatory: null,
      });
    }
  }, [data, setValue, trigger, open, reset]);

  return (
    <Dialog
      PaperProps={{ style: { maxWidth: 450 } }}
      open={open}
      keepMounted
      onClose={onClose.bind(null, false)}
      classes={{ paper: classes.dialog }}>
      <DialogTitle className={classes.dialogTitle}>{data?.id ? 'KKD Tanım Düzenleme' : 'KKD Tanım Ekle'}</DialogTitle>
      <DialogContent>
        <FormProvider {...{ ...formMethods, reset, setValue, trigger }}>
          <form noValidate className="mt-2" onSubmit={formMethods.handleSubmit(handleSubmit)}>
            <Grid container spacing={1}>
              <Grid item md={12} sm={12} lg={12}>
                <TextField type="text" name="label" label="Tanım Adı" />
              </Grid>
              <Grid item md={12} sm={12} lg={12}>
                <Checkbox name="isSerialNumberMandatory" label="Seri numarası zorunlu mu ? " />
              </Grid>
              <Grid item md={12} className="text-right">
                <Button variant="contained" type="submit" color="primary" className="mr-2">
                  {data?.id ? 'Güncelle' : 'Kaydet'}
                </Button>
                <Button variant="contained" type="button" onClick={onClose.bind(null, false)}>
                  Vazgeç
                </Button>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
